import React from "react";
import "../Assets/Styles.css";
import Typewriter from "typewriter-effect";
import Typography from "@material-ui/core/Typography";
import Divider from "@material-ui/core/Divider";
import useMediaQuery from "@material-ui/core/useMediaQuery";


function About() {
  const prefersDarkMode = useMediaQuery("(prefers-color-scheme: dark)");
  return (
    <div >
      <Typography variant="h2" component="h2" gutterBottom className="Header">
        ABOUT
      </Typography>
      <Divider />
      <div
        style={{
          color: prefersDarkMode?'whitesmoke':'#16213E',
          fontFamily: " 'Source Code Pro', monospace",
          display: "flex",
          textAlign: "left",
          justifyContent: "center",
          flexDirection: "column",
          fontSize: 50,
          width: "80%",
          margin:'auto',
          marginTop: "15%",
        }}
      >
        <Typewriter 
          options={{ loop: true }}
          onInit={(typewriter) => {
            typewriter
              .typeString("<strong style='color: #ffbc42'>I'M </strong>")
              .typeString("EDGARD GONZALEZ")
              .pauseFor(2000)
              .deleteChars(15)
              .typeString("ELECTRONIC ENGINEER")
              .pauseFor(2000)
              .deleteChars(19)
              .typeString("WEB DEVELOPER")
              .pauseFor(2000)
              .deleteChars(13)
              .typeString("DJ")
              .pauseFor(2000)
              .deleteChars(2)
              .start();
          }}
        />
      </div>
      
    </div>
  );
}

export default About;
